"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormSetting = exports.FormSettingProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hooks_1 = require("../hooks");
const Mapper_1 = require("../utils/Mapper");
const mapDroppedItemToFormInput_1 = require("../utils/mapDroppedItemToFormInput");
/**
 * ## FormSettingContext
 */
const FormSettingContext = (0, react_1.createContext)(undefined);
FormSettingContext.displayName = "FormSettingContext";
const FormSettingProvider = ({ children, sessionActiveCode }) => {
    const [selectedForm, setSelectedForm] = (0, react_1.useState)(null);
    const [filteredHtml, setFilteredHtml] = (0, react_1.useState)("");
    const [filteredSchema, setFilteredSchema] = (0, react_1.useState)(null);
    const [fields, setFields] = (0, react_1.useState)([]);
    const [forms, setForms] = (0, react_1.useState)([]);
    console.log("FormSettingProvider");
    const { currentSchema, setCurrentSchema, extractSchema } = (0, hooks_1.useSchemaManager)({
        userId: "example-user-123",
        onSchemaExtracted: (schema) => {
            console.log("✅ Schema extracted successfully:", schema);
        },
        onError: (error) => {
            console.error("❌ Schema extraction error:", error);
        },
    });
    // Add field to schema
    const addFieldToSchema = (item) => {
        var _a, _b;
        if (!currentSchema || !setCurrentSchema)
            return;
        // Check for duplicates based on whether it's a form item or not
        let filteredInputs;
        if (item.formId) {
            // For form items, check both id and formInputId to prevent duplicates
            console.log("Adding form item:", item);
            item.type =
                Mapper_1.TypeDropFormMapper[item.type] ||
                    item.type;
            item.options = (item.options || []).map((opt) => ({
                value: opt.value || opt.label || opt || "",
                label: opt.label || opt.value || opt || "",
                // Ensure isHidden is set
            }));
            const mappedItem = (0, mapDroppedItemToFormInput_1.mapDroppedItemToFormInput)(item, (_a = currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs) === null || _a === void 0 ? void 0 : _a.length);
            filteredInputs = currentSchema.inputs.filter((input) => input.id !== mappedItem.id &&
                input.formInputId !== mappedItem.formInputId);
        }
        else {
            // For non-form items, just check id
            filteredInputs = currentSchema.inputs.filter((input) => input.id !== item.id);
        }
        // Now map and add the new field
        const newInput = (0, mapDroppedItemToFormInput_1.mapDroppedItemToFormInput)(item, (_b = currentSchema === null || currentSchema === void 0 ? void 0 : currentSchema.inputs) === null || _b === void 0 ? void 0 : _b.length);
        const updatedSchema = Object.assign(Object.assign({}, currentSchema), { inputs: [...filteredInputs, newInput], metadata: Object.assign(Object.assign({}, currentSchema.metadata), { updatedAt: new Date() }) });
        setCurrentSchema(updatedSchema);
    };
    const handleRemoveForm = () => {
        setSelectedForm(null);
        setForms([]);
        // setGeneratedCode("");
        setFilteredHtml("");
        setFilteredSchema(null);
        setCurrentSchema(null);
        setFields([]);
        // setStatus("");
        // setError("");
        // setIsGenerating(false);
    };
    return ((0, jsx_runtime_1.jsx)(FormSettingContext.Provider, { value: {
            selectedForm,
            setSelectedForm,
            currentSchema: filteredSchema || currentSchema,
            generatedCode: filteredHtml || sessionActiveCode,
            originalSchema: currentSchema,
            handleRemoveForm,
            forms,
            setForms,
            addFieldToSchema,
            setCurrentSchema,
            filteredHtml,
            setFilteredHtml,
            setFilteredSchema,
            extractSchema,
        }, children: children }));
};
exports.FormSettingProvider = FormSettingProvider;
const useFormSetting = () => {
    const context = (0, react_1.useContext)(FormSettingContext);
    if (!context) {
        throw new Error("useFormSetting must be used within a FormSettingProvider");
    }
    return context;
};
exports.useFormSetting = useFormSetting;
